import React from 'react'
import MenuItem from '../MenuItem'
import {Box} from '@mui/material'
import {toast} from 'sonner'
import {useTranslation} from 'react-i18next'
import providers from 'constants/enum/meterProvider'
import {useSyncMeterMutation} from 'store/Store'

const MeterSyncMenuItem = ({Icon, itemId, title, rowData, handleClose, translationKey}) => {
    const [doSync] = useSyncMeterMutation()
    const {t} = useTranslation()

    if (rowData?.provider !== providers.ZEUSINT) return null

    const onClickHandler = (event) => {
        event?.stopPropagation()
        handleClose?.(event)

        toast.promise(
            doSync(itemId)
                .unwrap()
                .then((res) => res)
                .catch((error) => {
                    console.error('sync meter error', error)
                    throw error
                }),
            {
                loading: t('loading'),
                success: () => t(`${translationKey}.success`),
                error: () => t(`${translationKey}.error`),
            }
        )
    }

    return (
        <MenuItem key={`table_action_${itemId}`} onClick={onClickHandler}>
            <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
                <div>{t(`menuItem.${title}`)}</div>
                {Icon && <Icon />}
            </Box>
        </MenuItem>
    )
}

export default MeterSyncMenuItem
